import react from 'react'
import check from './../../../images/check.png'
import leftTeckBg from './../../../images/leftBg.png'



const First_Pane = () => (

<div>


         <div className="uk-container uk-margin-large-top">
                    <div className="uk-width-1-1 uk-flex uk-flex-center">
                        <div className="uk-grid " data-uk-grid>
                            <div className='uk-width-1-5@s'>

                            </div>
                        <div className="uk-width-3-5@s ">

                           <span className="introDiv "  role="img" aria-label="[Virtual Tech Camp]">

                            <h3 className="header3 uk-text-center ">Design your own game and video universe at  Tech Camps</h3>  
                             <p className="uk-text-center subText uk-margin-medium-top">Join CyberTeck during Spring Break and Summer time to offer your child the amazing experience of camp. 
                               Courses focused on design, animation and modelling in popular game universe like Minecraft,
                              Roblox or Scratch. We make sure he learns essential tech skills, you can relax knowing they have fun.</p>


                             </span>
                    </div>

                    <div className='uk-width-1-5@s'>
                    </div>
                    </div>
                  </div>   
             </div>




                 <div className="uk-grid uk-margin-small-top uk-margin-large-bottom" data-uk-grid>
                                   <div className="uk-width-1-2@l uk-margin-top ">
                                         <div className=" "  uk-scrollspy="cls: uk-animation-slide-left; repeat: true"
                                         
                                         
                                         style={{ backgroundImage: `url(${leftTeckBg})`,
                                         backgroundRepeat: 'no-repeat',
                                         backgroundSize: 'cover',
                                         height:'70vh',
                                         paddingBottom: '100px'
                                     
                                         
                                     
                                           }}
                                         
                                         
                                         
                                         
                                         >

                                         </div>
                                         
                                   </div>


                        <div className="uk-width-1-2@l">

                                  <div className="rightDivTeck">
                                      <div className="uk-margin-bottom uk-margin-medium-top">
                                            <h3 className="header3 uk-text-center ">Why Choose Tech Camps</h3>  
                                            <p className="uk-text-center subText uk-margin-small-top paddingRight">Trust experienced teachers to combine learning 
                                            and fun during Summer and Spring Break.</p>
                                        </div>

                                    <div className="uk-margin-medium-top">
                                         <div className="uk-grid-small uk-grid" data-uk-grid>
                                         <div className="uk-width-1-2@s">
                                         <div class="uk-flex">
                                                    <span uk-icon="icon: check; ratio: 4.5"></span>
                                                         <div class="uk-margin-left"   uk-scrollspy="cls: uk-animation-fade; repeat: true">
                                                            <h4 className="iconHeaderSmall">Schools and Parks & Rec Centers choose us</h4>
                                                            <p className="iconParagraphSmallTeck uk-margin-small-top">We know what makes students hungry for knowledge and how to motivate them. 
                                                                More than 10 years experience in developing tech abilities and building futures.</p>
                                                        </div>
                                                    
                                                    </div>
                                           </div>

                                           <div className="uk-width-1-2@s">
                                           <div class="uk-flex">
                                                    <span uk-icon="icon: check; ratio: 4.5"></span>
                                                         <div class="uk-margin-left"   uk-scrollspy="cls: uk-animation-fade; repeat: true">
                                                            <h4 className="iconHeaderSmall">Dedicated Tech Teachers</h4>
                                                            <p className="iconParagraphSmallTeck uk-margin-small-top">Selected from top tech experts, our educators awake students’ interest
                                                             and build up know-how and creativity in the fascinating world of tech.</p>
                                                        </div>
                                                    
                                                    </div>
                                         </div>
                                          </div>

                                    </div>





                                  
                                    <div className="uk-margin-medium-top">
                                         <div className="uk-grid-small uk-grid" data-uk-grid>
                                         <div className="uk-width-1-2@s">
                                         <div class="uk-flex">
                                                    <span uk-icon="icon: check; ratio: 4.5"></span>
                                                         <div class="uk-margin-left"   uk-scrollspy="cls: uk-animation-fade; repeat: true">
                                                            <h4 className="iconHeaderSmall">We make learning fun</h4>
                                                            <p className="iconParagraphSmallTeck uk-margin-small-top">We deliver education through game design, video
                                                             animations and modelling for students to build up tech skills and boost their confidence.</p>
                                                        </div>
                                                    
                                                    </div>
                                           </div>

                                           <div className="uk-width-1-2@s">
                                           <div class="uk-flex">
                                                    <span uk-icon="icon: check; ratio: 4.5"></span>
                                                         <div class="uk-margin-left"   uk-scrollspy="cls: uk-animation-fade; repeat: true">
                                                            <h4 className="iconHeaderSmall">Flexibility and adaptability</h4>
                                                            <p className="iconParagraphSmallTeck uk-margin-small-top">To fit the new present, we offer Virtual and at Locations
                                                             options. Check out our partnerships with Schools or Parks & Rec Centers or bring learning anywhere.</p>
                                                        </div>
                                                    
                                                    </div>
                                         </div>
                                          </div>

                                    </div>

                            </div>

                           
                           </div>


                </div>






                        
     </div>
);


export default First_Pane